var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12254_537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 4.58305H15.5833V3.66636C15.5833 2.65526 14.7611 1.83301 13.75 1.83301H8.25C7.2389 1.83301 6.41665 2.65521 6.41665 3.66636V4.58301H1.83335C0.822207 4.58305 0 5.40526 0 6.41636V9.16636C0 10.1775 0.822207 10.9997 1.83335 10.9997H9.1667V10.5414C9.1667 10.288 9.3717 10.083 9.62504 10.083H12.375C12.6284 10.083 12.8334 10.288 12.8334 10.5414V10.9997H20.1667C21.1778 10.9997 22 10.1775 22 9.16636V6.41636C22 5.40526 21.1778 4.58305 20.1667 4.58305ZM13.75 4.58305H8.25V3.66636H13.75V4.58305Z",
    fill: "#2045FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7458 11.4947C21.5896 11.4173 21.4029 11.4352 21.265 11.5399C20.9392 11.7865 20.5596 11.9168 20.1666 11.9168H12.8333V13.2918C12.8333 13.5451 12.6283 13.7501 12.375 13.7501H9.625C9.37166 13.7501 9.16665 13.5451 9.16665 13.2918V11.9168H1.83335C1.44036 11.9168 1.06081 11.7865 0.734937 11.5399C0.596621 11.4343 0.410437 11.4164 0.254203 11.4947C0.0984844 11.5722 0 11.731 0 11.9052V18.3335C0 19.3446 0.822207 20.1668 1.83335 20.1668H20.1667C21.1778 20.1668 22 19.3446 22 18.3335V11.9052C22 11.731 21.9015 11.5722 21.7458 11.4947Z",
    fill: "#2045FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12254_537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3);
export default __webpack_public_path__ + "static/media/a3.b6328767954b1d570c4d0663e72c7f36.svg";
export { ForwardRef as ReactComponent };